import axios from 'axios'
import { store } from './store'
import {
    setMaintenance,
    clearMaintenance,
} from '../../app/modules/maintenance/_redux/maintenanceSlice'

const setupAxios = axios.create({
    baseURL: process.env.REACT_APP_API_BACKEND_SERVICE_URL,
})

setupAxios.interceptors.request.use(
  

    (config) => {
        const {
            auth: { token },
        } = store.getState()
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (err) => Promise.reject(err)
)

setupAxios.interceptors.response.use(
    (response) => {
        const cfg = response?.config || {}
        if (!cfg.skipMaintenanceTracking) {
            const { maintenance } = store.getState()
            if (maintenance?.isMaintenance) {
                store.dispatch(clearMaintenance())
            }
        }
        return response
    },
    (error) => {
        const cfg = error?.config || {}
        const status = error?.response?.status
        if (status === 503 && !cfg.skipMaintenanceTracking) {
            store.dispatch(setMaintenance())
        }
        return Promise.reject(error)
    }
)

export default setupAxios
